import React, { useContext, useEffect, useState, useReducer } from 'react';
import { connect } from "react-redux"
import { Icon, Menu, Image, Sidebar, Container, Header, Button, Segment } from 'semantic-ui-react';
import { BrowserRouter as Router, Route, Link, Routes, useParams, useNavigate } from "react-router-dom";
import DropdownLangue from './DropdownLangue/DropdownLangue';
import DropdownUser from './DropdownUser/DropdownUser';
import Dashboard from './../../pages/Dashboard/Dashboard';
import Bookings from './../../pages/Booking/Bookings';
import AccountPage from './../../pages/AccountPage/AccountPage';
import BookingDetails from './../../pages/BookingDetails/BookingDetails';
import GlobalContext from './../../contexts/GlobalContext';
import { Parallax } from 'react-parallax';
import { config } from './../../Config';
import ConfigTheme from './../../Theme';
import PreCheckIn from './../../pages/PreCheckIn/PreCheckIn';
// import { toast } from 'react-toastify';
import useFromSelfCheckin from "../../hooks/useFromSelfCheckin";
import Establishment from './../../pages/Establishment/Establishment';
import Utility, {getUserIdentity} from "../../Utility";
import Footer from './Footer/Footer';
import './Navigation.css';
import { StickyContainer, Sticky } from 'react-sticky';
import PanierReducer from './../../contexts/PanierReducer';
import PanierContext from './../../contexts/PanierContext';
import Panier from '../Panier/Panier';
import CookieBanner from './CookieBanner/CookieBanner';
import Notifications from './../Notifications/Notifications';
import NotifContext from './../../contexts/NotifContext';
import ModalRedirect from './ModalRedirect/ModalRedirect';
import Auth from "../../Auth";
import PreCheckInV2 from '../../pages/PreCheckIn/PreCheckInV2'

/**
 * Component Navigation
 * 
 * @param {object} props.location
 */
const Navigation = (props) => {

  const [globalContext] = useContext(GlobalContext);
  const getPageActive = () => {
    const siteMap = Utility.getSiteMap(globalContext.translations);
    let pageActive = siteMap.dashboard.codePage;

    let pageEnCours = props.location.pathname.replace(Utility.getUrlBaseName() + '/', '');


    if (pageEnCours.length > 0) {
      let params = pageEnCours.split('/');
      if (siteMap[params[0]] !== undefined) {
        pageActive = siteMap[params[0]].codePage;
      }
    }

    return pageActive;
  }

  const [isVisibleState, setIsVisibleState] = useState(false);
  const [panierVisibleState, setPanierVisibleState] = useState(false);
  const [panierModalState, setPanierModalState] = useState(false)
  const [activeItemState, setActiveItemState] = useState(getPageActive());
  const [siteMapState, setListMapState] = useState({});
  const [panierState, panierDispatch] = useReducer(PanierReducer, {});
  const [panierMobileState, setPanierMobileState] = useState(false);
  const [notifVisibleState, setNotifVisibleState] = useState(false);
  const [notifVisibleMobile, setNotifVisibleMobile] = useState(false);
  const [notifState] = useContext(NotifContext);
  const [notifCount, setNotifCount] = useState(0);
  const [isModalRedirect, setIsModalRedirect] = useState(false)
  const [redirectType, setRedirectType] = useState('')
  const [isFromSelfCheckinState, setIsFromSelfCheckinState] = useState(false)

  const fromSelfCheckin = useFromSelfCheckin(props.location);

  let { token, lang, id } = useParams();
  let navigate = useNavigate();

  var bandeauImage = globalContext.establishment.bandeauImage;
  var logoImage = globalContext.establishment.logo;
  if ( globalContext.espaceClientByOrga && globalContext.id_etab_reference != "" && globalContext.id_etab_reference != globalContext.establishment.id ) {
    
    bandeauImage = globalContext.establishmentCollection[globalContext.id_etab_reference].bandeauImage;
    logoImage = globalContext.establishmentCollection[globalContext.id_etab_reference].logo;
    //globalContext.establishment.logo
  }

  // gestion multi etab
  useEffect(() => {
    if ( globalContext.espaceClientByOrga && Object.keys(globalContext.establishmentCollection).length > 0 ) {
      globalContext.translations.establishment = globalContext.translations.ourHotel;
    }
  }, [globalContext.establishment.id])

  useEffect(() => {
    panierDispatch({ type: "INIT"});
  },[]);
  
  useEffect(() => {
    setListMapState(Utility.getSiteMap(globalContext.translations));
  }, [globalContext.translations]);

  useEffect(() => {
    if (panierVisibleState || notifVisibleState) {
      document.getElementById('main').style.maxHeight = '63vh';
      document.getElementById('footer').style.display = 'none';
    } else {
      document.getElementById('main').style.maxHeight = '100%';
      document.getElementById('footer').style.display = 'block';
      if (fromSelfCheckin.isFromSelfCheckin) {
        document.getElementById('main').style.minHeight = '60vh';
      }
    }
  }, [panierVisibleState, notifVisibleState])

  useEffect(() => {
    setNotifCount(notifState.notifs.length)
  }, [notifState.notifs])

  useEffect(() => {
    let elementExists = document.querySelector('#menu-notif');
    if( typeof(elementExists) != 'undefined' && elementExists != null ){
      if(notifVisibleMobile && !fromSelfCheckin.isFromSelfCheckin) {
        document.querySelector('#menu-notif').style.width = '100%'
      } else if (!fromSelfCheckin.isFromSelfCheckin) {
        document.querySelector('#menu-notif').style.width = '30%'
      }
    }
    
  }, [notifVisibleMobile])

  const handleItemMobileClick = () => setIsVisibleState(false);
  const handleShowClick = () => { setIsVisibleState(true); setPanierVisibleState(false) };
  const handleSidebarHide = () => { gestionOverFlowMenuMobile(); setIsVisibleState(false); }
  const handlePanierHide = () => { setPanierVisibleState(false); }

  /**
   * envent au click deconnecte
   */
  const handleClickDisconnect = () => {
    Auth.logout();
  }

  const getPanier = (mobile) => {
    mobile ? setPanierMobileState(true) : setPanierMobileState(false);
    setPanierVisibleState(true);
    setPanierModalState(false);
  }

  const getPanierLength = () => {
    let count = 0;
    const sessionPanier = JSON.parse(sessionStorage.getItem('panierState'));
    if (sessionPanier && sessionPanier.orders.length > 0) {
      sessionPanier.orders.forEach(order => {
        order.bookings.forEach(booking => {
          booking.supplements.forEach(suppl => {
            count++;
          })
        })
      })
    }
    return count;
  }

  const getListPage = () => {
    const listPage = {
      desktop: [],
      mobile: [
        <Menu.Item as="div" className="text-left" onClick={(e) => {props.handleRedirectType(() => {handleItemMobileClick()},e)}} key={'itemVide'}>
          <div style={{ height: '25px' }}>&nbsp;</div>
        </Menu.Item>
      ],
    };

    let listPageTemp = [];
    if (Object.entries(siteMapState).length > 0) {
      listPageTemp = [
        siteMapState.dashboard.codePage,
      ];

      if (globalContext.displayControl.bookingsListing) {
        listPageTemp.push(siteMapState.bookings.codePage);
      }

      listPageTemp.push(siteMapState.establishment.codePage);
      listPageTemp.push(siteMapState.account.codePage);
      //siteMapState.panier.codePage,

      if (props.hasModule && globalContext.displayControl.messaging) {
        listPageTemp.push(siteMapState.notif.codePage);
      }
    }

    if (siteMapState && Object.entries(siteMapState).length > 0) {
      for (let index in listPageTemp) {// eslint-disable-line no-unused-vars
        let { header, codePage } = siteMapState[listPageTemp[index]];

        if (codePage === 'account') {
          listPage.desktop.push(
            <Menu.Menu
              position="right"
              key={codePage}
            >
              <DropdownLangue
                navigate={navigate}
                location={props.location}
                currentCodePage={activeItemState}
              />
              <DropdownUser
                className={(activeItemState === 'account') ? 'active' : null}
                location={props.location}
                setActiveItemMenu={setActiveItemState}
                setIsModalRedirect={setIsModalRedirect}
                setRedirectType={setRedirectType}
                
              />
            </Menu.Menu>
          );
        } else if (codePage === 'panier') {
          listPage.desktop.push(
            <Menu.Menu
              position="left"
              key={codePage}
            >
              <Button
                style={{ opacity: '.95', background: 'transparent' }}
                onClick={() => {
                  props.handleRedirectType(() => {
                    getPanier(false)
                  })
                }}
                primary
                >
                <Icon style={{ color: 'white' }} name={Utility.getIconPage('panier')} /><span className="font-weight-bold">{getPanierLength()}</span>
              </Button>
            </Menu.Menu>
          );
        } else if (codePage === 'notif'  ) {
          listPage.desktop.push(
            <Menu.Menu
              position="left"
              key={codePage}
            >
              <Button
                style={{ opacity: '.95', background: 'transparent' }}
                onClick={() => {
                  props.handleRedirectType(() => {
                    setNotifVisibleMobile(false);
                    setNotifVisibleState(true)
                  })
                }}
                color="blue"
                >
                <Icon style={{ color: 'white' }} name={Utility.getIconPage('notif')} /><span className="font-weight-bold">{notifCount}</span>
              </Button>
            </Menu.Menu>
          );
        } else {
          listPage.desktop.push(
            <Menu.Item as={Link}
              to={Utility.getUrlPage(globalContext, codePage)}
              name={codePage}
              style={ConfigTheme.color}
              active={activeItemState === codePage}
              onClick={(e) => {
               props.handleRedirectType(() => {
                 setActiveItemState(codePage);
               }, e)
              }}
              key={codePage}
            >
              {((header) ? header : codePage).toUpperCase()}
            </Menu.Item>
          );
        }

        if (codePage !== 'panier' && codePage !== 'notif') {
          /* listPage.mobile.push(
            <Menu.Item
              name={codePage}
              onClick={getPanier}
              key={codePage}
              >
              <Icon name={siteMapState[listPageTemp[index]].icon} />
              {((header) ? header : codePage).toUpperCase()}
            </Menu.Item>
          ); */
          if (codePage === 'account') {
            let keyLink = 'personalInformation';

            listPage.mobile.push(

              <Menu.Item
                as={Link}
                to={Utility.getUrlPage(globalContext, keyLink)}
                name={codePage}
                onClick={(e) => {props.handleRedirectType(() => {handleItemMobileClick()},e)}}
                key={keyLink}
                className="tuileMenu"
              >
                <div >
                  <div className="divIconMenu">
                    <Icon className="iconMenu" name={siteMapState[listPageTemp[index]].icon} />
                  </div>
                  <div className="titleMenu">
                    {((header) ? header : codePage).toUpperCase()}
                  </div>
                </div>
              </Menu.Item>
  
            );
          }
          else{
            listPage.mobile.push(

              <Menu.Item
                as={Link}
                to={Utility.getUrlPage(globalContext, codePage)}
                name={codePage}
                onClick={(e) => {props.handleRedirectType(() => {handleItemMobileClick()},e)}}
                key={codePage}
                className="tuileMenu"
              >
                <div >
                  <div className="divIconMenu">
                    <Icon className="iconMenu" name={siteMapState[listPageTemp[index]].icon} />
                  </div>
                  <div className="titleMenu">
                    {((header) ? header : codePage).toUpperCase()}
                  </div>
                </div>
              </Menu.Item>
  
            );
          }
          
        }
      }
      if (globalContext.authenticationStatus == 1) {
        
        listPage.mobile.push(
          <Menu.Item
            as='a'
            onClick={handleClickDisconnect}
            key="disconnect"
            className="tuileMenu"
          >
            <div >
              <div className="divIconMenu">
                <Icon className="iconMenu" name="log out" />
              </div>
              <div className="titleMenu">
                {globalContext.translations.disconnect.toUpperCase()}
              </div>
            </div>
          </Menu.Item>
        )
      }
    }
    return listPage;
  }

  const gestionOverFlowMenuMobile = () => {
    let menu = document.getElementById('menu-mobile');

    if (menu) {
      if (isVisibleState === true) {
        menu.style.top = window.pageYOffset + 'px';
        document.body.classList.add('noScroll');
      } else {
        document.body.classList.remove('noScroll');
      }
    }
  }

  const getParallax = () => {
    let height = {
      desktop: 140,
      mobile: 90
    }
    let classParallaxSelfCheckin = '';

    return (
      <Parallax bgImage={bandeauImage} strength={900}>
        <div className="divParallax">
          <Header textAlign="center">
            {/*<Segment maxWidth={768} style={{ height: height.mobile }}></Segment>
            <Segment minWidth={769} style={{ height: height.desktop }}></Segment>*/}
            <Segment compact className="blur-title segmentNotBoxShadow" textAlign="center">
              <h1 id="welcome-title">
                <div>{globalContext.translations.welcome}&nbsp;</div>
                <div>{getUserIdentity(globalContext.user.civility, globalContext.user.lastName, globalContext.user.society, globalContext.user.firstName )}</div> 
              </h1>            
            </Segment>
          </Header>
        </div>
      </Parallax>
    )
  }

  const getMenuToolBarMobile = () => {
    return (
        <Menu borderless id="menuToolbarMobile" className="menu-app">
          <div className="blur-nav blur-nav-mobile-height"></div>
          <Menu.Item className="mr-4" onClick={handleShowClick} >
            <Icon name="bars" style={ConfigTheme.color} />
          </Menu.Item>
          {/* <Menu.Item className="mr-4">
            <Image src={globalContext.establishment.logo} size="tiny" centered />
          </Menu.Item> 
          <Menu.Menu
            position="left"
            key={'panier'}
          >
            <Button style={{ opacity: '.95', background: 'transparent' }} onClick={() => {props.handleRedirectType(() => {getPanier(true)})}} primary >
              <Icon style={{ color: 'white' }} name={Utility.getIconPage('panier')} /><span className="font-weight-bold">{getPanierLength()}</span>
            </Button>
          </Menu.Menu>*/}
          { // SI MESSAGERIE ACTIVEE
            globalContext.displayControl.messaging
            ?
            <Menu.Menu
              position="left"
              key={'notif'}
            >
              <Button
                  style={{ opacity: '.95', background: 'transparent' }}
                  onClick={() => {props.handleRedirectType(() => {setNotifVisibleState(true); setNotifVisibleMobile(true);})}}
                  color="blue"
                  >
                  <Icon style={{ color: 'white' }} name={Utility.getIconPage('notif')} /><span className="font-weight-bold">{notifCount}</span>
                </Button>
            {/*  <Button style={{ opacity: '.95', background: 'transparent' }} onClick={() => getPanier(true)} color="blue" >
                <Icon style={{ color: 'white' }} name={Utility.getIconPage('notif')} /><span className="font-weight-bold">{getPanierLength()}</span>
              </Button> */}
            </Menu.Menu>
            : ""
          }
          
          <Menu.Menu
            position="right"
            key={'account'}
          >
            <DropdownLangue navigate={navigate} currentCodePage={activeItemState} location={props.location} className="mt-1" />
          </Menu.Menu>
        </Menu>
    )
  }

  const getMenuToolBarDesktop = () => {
    return (
        <Menu borderless id="menuToolbarDesktop" className="menu-app" >
          <div className="blur-nav blur-nav-height"></div>
          <Menu.Item className="mr-4 logo-nav">
            <Image src={logoImage} size="tiny" centered />
          </Menu.Item>
          {listPage.desktop}
        </Menu>
    )
  }

  const getRoute = () => {

    if (siteMapState && Object.entries(siteMapState).length > 0) {

      if (activeItemState === "establishment") {
        return <Establishment />;
      }
      else if (activeItemState === "dashboard") {
        return <Dashboard />;
      }
      else if (activeItemState === "checkin" || activeItemState === "checkinV2" || activeItemState === "preCheckIn") {
        return <PreCheckInV2 location={props.location} />;
      }
      /*else if ( (activeItemState === "checkin" || activeItemState === "checkinV2" || activeItemState === "preCheckIn") && id === undefined) {
        return <PreCheckIn location={props.location} />;
      }*/
      else if (activeItemState === "account") {
        return <AccountPage location={props.location} />;
      }
      else if (activeItemState === "bookings" && id === undefined ) {
        return <Bookings />;
      }
      else if (activeItemState === "bookings" && id !== undefined ) {
        return <BookingDetails location={props.location} />;
      }
      else {
        return <Dashboard />;
      }

      /*return [
        <Route key={0} path={`/:token/:lang/`} exact /*Component={Dashboard}
          element={<Dashboard location={props.location} setActiveItemMenu={setActiveItemState} /> } 
        />,
        <Route key={1} path={`/:token/:lang${siteMapState['bookings'].url}`} exact Component={Bookings} />,
        <Route key={2} path={`/:token/:lang${siteMapState['bookings'].url}/:id/`} Component={BookingDetails} />,
        <Route key={3} path={`/:token/:lang${siteMapState['checkin'].url}`} exact Component={PreCheckIn} />,
        <Route key={4} path={`/:token/:lang${siteMapState['checkin'].url}/:id`} Component={PreCheckInV2} />,
        <Route key={6} path={`/:token/:lang${siteMapState['account'].url}/:codePage`} Component={AccountPage} />,
        <Route key={7} path={`/:token/:lang${siteMapState['account'].url}/`} exact Component={AccountPage} />,
        <Route key={8} path={`/:token/:lang${siteMapState['establishment'].url}`} Component={Establishment} />,
        <Route key={9} path={`/:token/:lang${siteMapState['checkinV2'].url}`} exact Component={PreCheckInV2} />,
        <Route key={10} path={`/:token/:lang${siteMapState['checkinV2'].url}/:id`} Component={PreCheckInV2} />,
        <Route path="/:token/:lang/selfCheckin" exact Component={LoginPageSelfCheckin} />
      ]*/
    } else {
      return null;
    }
  }

  let listPage = getListPage();

  return (

      fromSelfCheckin.isFromSelfCheckin === false ?
      <div>
        <ModalRedirect
          handleClose={props.handleModalRedirect}
          open={props.modalRedirect}
          langIso={lang}
          // setIsModalRedirect={setIsModalRedirect}
          // setIsModalRedirect={props.handleRedirect}
          // typeLink={redirectType}
          typeLink={props.modalRedirectType}
        />

        <PanierContext.Provider value={[panierState, panierDispatch]}>
          <Sidebar.Pushable>
            {/* NOTIFICATIONS MOBILE */}
            { // SI MESSAGERIE ACTIVEE
              globalContext.displayControl.messaging
              ?
              <Sidebar
                id="menu-notif"
                style={props.mobile ? {width: '100%'} : {}}
                direction="right"
                as={Menu}
                animation="push"
                icon="labeled"
                /* onVisible={(ev, el) => { ev.currentTarget.scrollTop = 0 }} */
                onHide={() => setNotifVisibleState(false)}
                vertical
                visible={notifVisibleState}
                width="thin"
              >
                <Notifications mobile={notifVisibleMobile} setNotifVisibleState={setNotifVisibleState}/>
              </Sidebar>
              : ""
            }
            

            {/* PANIER MOBILE */}
            <Sidebar
              id="menu-panier"
              style={panierMobileState ? {paddingTop: '0'} : null}
              direction="right"
              as={Menu}
              animation="push"
              icon="labeled"
              /* onVisible={(ev, el) => { ev.currentTarget.scrollTop = 0 }} */
              onHide={handlePanierHide}
              vertical
              visible={panierVisibleState}
              width="thin"
            >
              <Panier
                setPanierVisible={setPanierVisibleState}
                panierMobile={panierMobileState}
                panierState={panierState}
              />
            </Sidebar>

            {/* SIDEBAR MOBILE */}
            <Sidebar
              id="menu-mobile"
              as={Menu}
              className="pt-3"
              direction="left"
              inverted
              icon="labeled"
              animation="overlay"
              onVisible={gestionOverFlowMenuMobile()}
              onHide={handleSidebarHide}
              vertical
              visible={isVisibleState}
              width="thin"
            >
              <div className={!fromSelfCheckin.isFromSelfCheckin ? "mt-5" : ""}>
                {listPage.mobile}
              </div>
            </Sidebar>

            <Sidebar.Pusher>
              {getParallax()}
              <main id="main">
                <Container className="pb-5" style={{minHeight: '50vh'}}>
                  {getRoute()}
                </Container>
              </main>
            </Sidebar.Pusher>
            <Footer/>
          </Sidebar.Pushable>

          <StickyContainer>
            <Sticky id="sdqsd">
              {({ style }) => (
                <div>
                  {getMenuToolBarMobile()}
                  {getMenuToolBarDesktop()}
                </div>
              )}
            </Sticky>
          </StickyContainer>
          {/* <Modal className="supplement-modal" open={panierModal} onClose={() => setPanierModalState(false)} closeIcon>
        <Modal.Content>
            <div style={{textAlign: 'center'}}>
                <Message icon size="small" positive>
                  <Icon name="check" />
                  <Message.Header>Panier mis à jour avec succès</Message.Header>
                </Message>
                <Button.Group size="large">
                  <Button onClick={() => setPanierModalState(false)}>Retour</Button>
                  <Button.Or />
                  <Button positive onClick={getPanier}>Voir panier</Button>
                </Button.Group>
              </div>
        </Modal.Content>
        }
      </Modal> */}
          <CookieBanner
            token={token}
            lang={lang}
            translations={globalContext.translations}
            legalInfo={globalContext.legalInfo}
          />
        </PanierContext.Provider>

      </div>

      :

      <Sidebar.Pushable>
        <Sidebar.Pusher>
          <Header className="header-selfCheckin">
            <Segment compact className="blur-title segmentNotBoxShadow" textAlign="center" style={{margin: "auto"}}>
              <h1 id="welcome-title"><div>{globalContext.translations.welcome}</div> <div>{getUserIdentity(globalContext.user.civility, globalContext.user.lastName, globalContext.user.society, globalContext.user.firstName)}</div> </h1>
            </Segment>
          </Header>
          <main id="main">
            <Container className="pb-5" style={{minHeight: '50vh'}}>
              <Routes>
                {getRoute()}
              </Routes>
            </Container>
          </main>
        </Sidebar.Pusher>
        <Footer/>
      </Sidebar.Pushable>
  )
};

window.onscroll = function () {
  if (window.scrollY > 0) {
    let els = document.getElementsByClassName("blur-nav");
    Array.prototype.forEach.call(els, function (element) {
      element.classList.add("blur-nav-scrolled");
      element.classList.remove("blur-nav");
    });
  } else {
    let els = document.getElementsByClassName("blur-nav-scrolled");
    Array.prototype.forEach.call(els, function (element) {
      element.classList.remove("blur-nav-scrolled");
      element.classList.add("blur-nav");
    });
  }
};

// export default Navigation;

const mapProps = state => ({
  hasModule: state.authentication.hasModule,
  modalRedirect: state.authentication.modalRedirect,
  modalRedirectType: state.authentication.modalRedirectType
})

const mapDispatch = dispatch => ({
  handleModalRedirect: dispatch.authentication.handleRedirect,
  handleRedirectType: dispatch.authentication.handleRedirectType
})

export default connect(mapProps, mapDispatch)(Navigation);